<template>
  <div id="homeManage">
    <el-container>
      <!-- <el-header>Header</el-header> -->
      <el-container>
        <sidebar></sidebar>
        <el-main>
            <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import sidebar from '@/components/main/sidebar.vue'
export default {
  data(){
    return{

    }
  },
  components:{
      sidebar
  }
}
</script>

<style lang="less" scoped>
#homeManage {
  height: 100%;
}
.el-container {
  height: 100%;
}
.el-header {
  background-color: skyblue;
}

.el-main {
  background-color: #F0F0F0;
  padding: 10px;
}

</style>